const REGEX = {
    LOGIN_ID: /^[A-Za-z][A-Za-z0-9]{5,19}$/,
    LOGIN_PW: /^[A-Za-z][A-Za-z0-9!*]{5,19}$/,
}

export {REGEX}